// @flow

import React from "react";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";

const SECONDS_PER_DAY = 86400;

export type Props = $Exact<{
  value: number,
  required: boolean,
  options: Object,
  onChange: (value: number) => {},
}>;

export class SecondsAsDaysInput extends React.Component<Props> {
  toDays = (seconds: number) =>
    isNaN(seconds) ? 0 : Math.round((seconds / SECONDS_PER_DAY) * 10) / 10;

  toSeconds = (hours: number) => hours * SECONDS_PER_DAY;

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(
      !isNaN(event.currentTarget.value)
        ? this.toSeconds(+event.currentTarget.value)
        : this.props.value,
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="form-control__with-label">
          <input
            type="number"
            className="form-control"
            value={this.toDays(this.props.value) || null}
            required={this.props.required}
            onChange={this.handleChange}
          />
          <label>days</label>
        </div>
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default SecondsAsDaysInput;
